import { render } from "./CountryCard.vue?vue&type=template&id=de9b0bea&scoped=true"
import script from "./CountryCard.vue?vue&type=script&lang=js"
export * from "./CountryCard.vue?vue&type=script&lang=js"

import "./CountryCard.vue?vue&type=style&index=0&id=de9b0bea&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9b0bea"]])

export default __exports__